<script>

    import { toast } from 'bulma-toast'
    import { modalStore, chargesStore, chargeStore, notifyStore } from '../stores'

    import ChargesService from '../$services/charges.service'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import Button from '../$components/button.svelte'

    let data = {
        _id: $chargeStore._id,
        concept: $chargeStore.concept,
        details: $chargeStore.details,
        amount: $chargeStore.amount,
        status: $chargeStore.status,
    }

    let loading = false

    $: lockedAmount = $chargeStore.status === 'paid' && data.status === 'paid'

    async function updateCharge() {

        const status = data.status
        const body = lockedAmount ? {...data, amount: $chargeStore.amount} : data

        loading = true
        const resp = await ChargesService.updateCharge(data._id, body)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.replace(resp.data)
        chargeStore.set(resp.data)

        if(status === 'paid' && resp.data.status !== 'paid')
            toast({message: 'Cargo actualizado, sin saldo suficiente para cobrarlo', type: 'is-warning'})
        else
            toast({message: 'Cargo actualizado', type: 'is-success'})

        notifyStore.set('wallet_updated')
        modalStore.set('charge_modal')
    }

</script>

<Form on:submit={ updateCharge } { loading } >
    <div class="columns">
        <div class="column">
            <Select bind:value={ data.status }
                label="Estatus"
                options={[
                    {value: 'review', text: 'Revisión'},
                    {value: 'pending', text: 'Pendiente'},
                    {value: 'paid', text: 'Pagado'},
                ]}
            />
        </div>
        <div class="column">
            <InputNumber bind:value={ data.amount } label="Monto" placeholder="Monto" min="0.01" readonly={ lockedAmount } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.concept } label="Concepto" placeholder="Concepto" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.details } label="Detalles" placeholder="Detalles" required={ false } />
        </div>
    </div>
    {#if $chargeStore.status === 'paid' && data.status !== 'paid'}
        <p class="help is-warning mb-4">El monto del cargo se regresará al saldo del usuario.</p>
    {:else if $chargeStore.status !== 'paid' && data.status === 'paid'}
        <p class="help is-warning mb-4">El monto se descontará del saldo del usuario.</p>
    {:else if lockedAmount}
        <p class="help mb-4">El monto de un cargo pagado no se puede cambiar.</p>
    {/if}
    <div class="items-end">
        <div class="buttons">
            <ButtonModal modalId="charge_modal" text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>
